import React from 'react';

import { Box } from '@/shared/ui/box';
import { BodyTextRegularB } from '@/shared/ui/typography2';

import { BackIconImageWrapper, CarretRightIcon } from './styles';

export const BackButton = ({ onClick, t }) => (
  <BackIconImageWrapper onClick={onClick}>
    <Box>
      <CarretRightIcon path="#AFAFAF" />
    </Box>
    <BodyTextRegularB color="#AFAFAF">{t('wallet.back')}</BodyTextRegularB>
  </BackIconImageWrapper>
);
